import e, { memo as A } from "react";
import { useTheme as k, AccordionItem as $, AccordionButton as z, Flex as H, HStack as I, Heading as v, Box as y, VisuallyHidden as T, AccordionIcon as B, AccordionPanel as C } from "@chakra-ui/react";
import { Icon as _ } from "../../atoms/icon/icon.js";
import "@loadable/component";
import { MdArrowBack as h } from "@react-icons/all-files/md/MdArrowBack";
const V = A(
  ({
    heading: r,
    children: m,
    showBackIcon: o,
    backClickHandler: s,
    shouldShowActiveIndicator: p = !1,
    selectedFIlterIndicatorA11y: b = ""
  }) => {
    const {
      element: u,
      icon: f,
      browseSidebarAccordionTitleText: g,
      filterSortItemHeight: x,
      borderStyle: E,
      interactive: c,
      accordionIcon: i,
      activeFilterIcon: S
    } = k(), { color: n, style: a, width: d } = E.default, { accent1: l } = f, { spacingMedium: t } = u;
    return /* @__PURE__ */ e.createElement(
      $,
      {
        key: r,
        borderBottom: `${n} ${a} ${d}`,
        borderTop: 0,
        "data-testid": "accordion-item"
      },
      /* @__PURE__ */ e.createElement(
        z,
        {
          boxSizing: "content-box",
          minHeight: x,
          paddingY: t,
          paddingX: 0,
          borderBottom: o ? `${n} ${a} ${d}` : "0",
          _hover: { background: c.background }
        },
        /* @__PURE__ */ e.createElement(H, { flex: 1, textAlign: "left" }, o && /* @__PURE__ */ e.createElement(
          _,
          {
            "data-testid": "accordion-back-icon",
            color: l,
            as: h,
            fontSize: i,
            onClick: () => s,
            pr: t
          }
        ), /* @__PURE__ */ e.createElement(I, null, /* @__PURE__ */ e.createElement(
          v,
          {
            as: "p",
            "data-testid": "accordion-title",
            sx: g
          },
          r
        ), p && /* @__PURE__ */ e.createElement(
          y,
          {
            backgroundColor: c.selected,
            borderRadius: "50%",
            ml: t,
            boxSize: S,
            "data-testid": "accordion-active-indicator"
          },
          /* @__PURE__ */ e.createElement(T, null, b)
        ))),
        !o && /* @__PURE__ */ e.createElement(
          B,
          {
            "data-testid": "accordion-icon",
            color: l,
            fontSize: i,
            spacing: t
          }
        )
      ),
      /* @__PURE__ */ e.createElement(
        C,
        {
          pb: 4,
          pt: 0,
          pl: 0,
          pr: 0,
          sx: { "li::marker": { fontSize: "0" } }
        },
        m
      )
    );
  }
);
export {
  V as CustomAccordionItem
};
